<div class="content">
    <div class="d-container d-md-flex align-items-center mb-4" *ngIf="detailsData?.length >= 1">
        @for(detail of detailsData; track $index) {
            <div class="div finance py-2 px-1">
                <p>{{ detail.split('|')[0] }}</p>
                <p class="sm-bold mt-1">{{ detail.split('|')[1] }}</p>
            </div>
        }
    </div>

    <div class="content1 align-items-center" *ngIf="opSection?.opportunityData">
        <p [innerHTML]="opSection.opportunityDescription | safeHtml">
            Cuitzeo #202 es un proyecto que ofrece a los inversionistas una forma segura y atractiva de obtener ingresos. Al invertir, se convierten en socios con un flujo de ingresos estables, disfrutando de rendimientos fijos bimestrales durante 60 meses. Al final del plazo, los inversionistas recuperan su capital inicial. Esta estructura proporciona tanto beneficios periódicos como la devolución íntegra de la inversión.
        </p>
    </div>
</div>